import AuthService from "./authService";

class ProvedorAutenticacao {

    iniciarSessao = (userCallback, loginObject)=>{
        loginObject
        const usuario = userCallback.user
        usuario.authorization = userCallback.authorization
        AuthService.logar(usuario)
        const auth = { 
            isAuthenticated: true, 
            userAuthenticated: usuario, 
            authorization: userCallback.authorization 
        }
        return auth
    }
    
    encerrarSessao = () => {
        AuthService.removerUsuarioAutenticado();
        const auth = { isAuthenticated: false, userAuthenticated: null, authorization: null }
        return auth
    }

    getProvider(){
        return {
            iniciarSessao: this.iniciarSessao,
            encerrarSessao: this.encerrarSessao,
        }
    }

}

export default ProvedorAutenticacao